// The web side of linking devices and accounts — iOS AccountLinking.swift.
//
// The rules live on the server (functions/identity/linking/policy.js) and
// nowhere else: an account is used on one device at a time unless it is
// premium, two accounts merge only if one of them is premium, and nothing
// is decided from what a QR code claims about the other device.

import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { deviceInfos, deviceLinkID } from "./pairing";

export function callable(name, options) {
  return httpsCallable(functions, name, options);
}

/** Why a linking callable refused (`details.reason`), or null. */
export function linkErrorReason(err) {
  return (err && err.details && typeof err.details.reason === "string")
    ? err.details.reason
    : null;
}

const REASON_KEYS = {
  "premium-required": "linking.premiumRequired",
  "already-linked": "linking.alreadyLinked",
  "pairing-not-found": "linking.codeExpired",
  "pairing-expired": "linking.codeExpired",
  "pairing-used": "linking.codeExpired",
  "invalid-secret": "linking.codeExpired",
  "account-pending-deletion": "linking.pendingDeletion",
  "merge-in-progress": "linking.mergeInProgress",
  "account-merged": "linking.accountMergedElsewhere",
};

/** The i18n key of the message for a refusal reason (or error). */
export function linkReasonKey(reasonOrError) {
  const reason = typeof reasonOrError === "string"
    ? reasonOrError
    : linkErrorReason(reasonOrError);
  return REASON_KEYS[reason] || "profile.pairing.error";
}

/** This browser, as every linking callable expects it. */
export async function deviceFields() {
  const info = await deviceInfos("");
  return {
    deviceID: deviceLinkID(),
    deviceKind: "web",
    deviceName: info.model || info.systemName || "Web",
  };
}

// How the session reached this browser, for the next seat claim
// ("signin" after a QR sign-in, "merge" after following a merge).
const SEAT_PENDING_KEY = "device_seat_pending_via";

export function markSeatPending(via) {
  try { localStorage.setItem(SEAT_PENDING_KEY, via); } catch (_) { /* ignore */ }
}

export function takeSeatPending() {
  try { return localStorage.getItem(SEAT_PENDING_KEY); } catch (_) { return null; }
}

export function clearSeatPending() {
  try { localStorage.removeItem(SEAT_PENDING_KEY); } catch (_) { /* ignore */ }
}
